/* eslint-disable no-useless-computed-key */
interface IVendorEvaluationFormQuestion {
  sequence: number
  topic: string
  detail: string[]
  weight: number
}

interface IVendorEvaluationForm {
  questions: IVendorEvaluationFormQuestion[]
}

const vendorEvaluationForm1: IVendorEvaluationForm = {
  questions: [
    {
      sequence: 1,
      topic: 'คุณภาพ',
      detail: ['คุณภาพของสินค้า สมบูรณ์ ไม่เสียหาย', 'คุณภาพการบริการติดตั้ง การส่งสินค้า เป็นไปตามมาตรฐาน'],
      weight: 35,
    },
    {
      sequence: 2,
      topic: 'การตรงต่อเวลา',
      detail: [
        'จัดส่งสินค้าหรือติดตั้งได้ครบถ้วน ตามวันและเวลาที่ตกลงกัน',
        'เมื่อมีการนัดหมายเข้างาน สามารถเข้างานได้ตรงเวลาตามที่นัดหมาย',
      ],
      weight: 30,
    },
    {
      sequence: 3,
      topic: 'การบริการก่อน-หลังการขาย',
      detail: [
        'ให้ความประทับใจในการให้บริการ',
        'การแก้ไขปัญหาหลังการส่งมอบ',
        'มีการให้ความช่วยเหลืออย่างรวดเร็วเมื่องานมีปัญหา',
      ],
      weight: 15,
    },
    {
      sequence: 4,
      topic: 'การติดต่อประสานงาน',
      detail: [
        'การติดต่อประสานงาน รวดเร็ว ฉับไว มีประสิทธิภาพ',
        'ความเรียบร้อยของเอกสารการวางบิล สมบูรณ์ ถูกต้อง ตรงเวลา',
      ],
      weight: 10,
    },
    {
      sequence: 5,
      topic: 'ความคุ้มค่า',
      detail: ['สินค้าหรือบริการที่ได้รับมีความคุ้มค่าสมราคา'],
      weight: 10,
    },
  ],
}

export const vendorEvaluationForms: Record<number, IVendorEvaluationForm> = {
  [1]: vendorEvaluationForm1,
}
